import { useCallback, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import Social from "./Social";
import externalUrls from "./externalUrls";
import { ReactComponent as StakeIcon } from "../../assets/icons/stake.svg";
import { ReactComponent as BondIcon } from "../../assets/icons/bond.svg";
import { ReactComponent as DashboardIcon } from "../../assets/icons/dashboard.svg";
//import { ReactComponent as GWSLogo } from "../../assets/icons/gws-finance-logo-dark.svg";
import GWSLogoDark from "../../assets/icons/gws-finance-logo-dark.svg";
import GWSLogoLight from "../../assets/icons/gws-finance-logo-white.svg";
import { ReactComponent as PoolTogetherIcon } from "../../assets/icons/33-together.svg";
import { trim, shorten } from "../../helpers";
import { useAddress, useWeb3Context } from "src/hooks/web3Context";
import useBonds from "../../hooks/Bonds";
import { Paper, Link, Box, Typography, SvgIcon } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import "./sidebar.scss";
import useTheme from "src/hooks/useTheme";

function NavContent() {
  let themeMode = localStorage.getItem('theme');
  const [isActive] = useState();
  const address = useAddress();
  const { bonds } = useBonds();
  const [theme, toggleTheme, mounted] = useTheme();

  const { chainID } = useWeb3Context();

  const checkPage = useCallback((match, location, page) => {
    const currentPath = location.pathname.replace("/", "");
    if (currentPath.indexOf("dashboard") >= 0 && page === "dashboard") {
      return true;
    }
    if (currentPath.indexOf("stake") >= 0 && page === "stake") {
      return true;
    }
    if ((currentPath.indexOf("bonds") >= 0 || currentPath.indexOf("choose_bond") >= 0) && page === "bonds") {
      return true;
    }
    return false;
  }, []);


  useEffect(() => {
    themeMode = localStorage.getItem('theme');
  }, [localStorage.getItem('theme')]);

  return (
    <Paper className="dapp-sidebar">
      <Box className="dapp-sidebar-inner" display="flex" flexDirection="column">
        <div className="dapp-menu-top">
          <Box className="branding-header">
            <Link href="https://app.gws.finance/" target="_blank">
              {themeMode === 'light'
                ? <img className="logo-dark" src={GWSLogoDark} alt="GWS Finance" />
                : <img className="logo-light" src={GWSLogoLight} alt="GWS Finance" />
              }
            </Link>
          </Box>

          <div className="dapp-menu-links">
            <div className="dapp-nav" id="navbarNav">
              <Link
                component={NavLink}
                id="dash-nav"
                to="/dashboard"
                isActive={(match, location) => {
                  return checkPage(match, location, "dashboard");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <span><i className="fa-light fa-objects-column"></i></span>
                <Typography variant="h6">
                  Dashboard
                </Typography>
              </Link>

              <Link
                component={NavLink}
                id="stake-nav"
                to="/"
                isActive={(match, location) => {
                  return checkPage(match, location, "stake");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <span><i className="fa-light fa-hexagon"></i></span>
                <Typography variant="h6">
                  Stake
                </Typography>
              </Link>

              <Link
                component={NavLink}
                id="bond-nav"
                to="/bonds"
                isActive={(match, location) => {
                  return checkPage(match, location, "bonds");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <span><i className="fa-light fa-layer-group"></i></span>
                <Typography variant="h6">
                  Bond
                </Typography>
              </Link>
              <Link
                href='https://app.uniswap.org/#/swap?exactField=input&exactAmount=1&inputCurrency=0x6B175474E89094C44Da98b954EedeAC495271d0F&outputCurrency=0x36F17BD0F7028c784b2e0C9B5a65dBe071a902d7&chain=mainnet'
                target='_blank'
                className={`button-dapp-menu ${isActive ? "active" : ""}`}>
                <span><i class="fa-light fa-coin-blank"></i></span>
                <Typography variant="h6">
                  Purchase GWS
                </Typography>
              </Link>

              <div className="dapp-menu-data discounts">
                <div className="bond-discounts">
                  <Typography variant="body2">Bond discounts</Typography>
                  {bonds.map((bond, i) => (
                    <Link component={NavLink} to={`/bonds/${bond.name}`} key={i} className={"bond"}>
                      {!bond.bondDiscount ? (
                        <Typography variant="body2">
                          {bond.displayName}
                          <span className="bond-pair-roi">
                            ⏳
                          </span>
                        </Typography>
                      ) : (
                        <Typography variant="body2">
                          {bond.displayName}
                          <span className="bond-pair-roi">
                            {bond.bondDiscount && trim(bond.bondDiscount * 100, 2)}%
                          </span>
                        </Typography>
                      )}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Box className="dapp-menu-bottom dapp-nav" display="flex" flexDirection="column">
          <div className="dapp-menu-title">
            <Typography variant="h6">Other</Typography>
          </div>
          <div className="dapp-menu-external-links">
            {Object.keys(externalUrls).map((link, i) => {
              return (
                <Link className={externalUrls[link].disabled ? 'disabled' : ''} key={i} href={`${externalUrls[link].url}`} target="_blank">
                  <span>{externalUrls[link].icon}</span>
                  <Typography variant="h6">{externalUrls[link].title}</Typography>
                </Link>
              );
            })}
          </div>
        </Box>
        <div className="dapp-menu-social">
          <Social />
        </div>
      </Box>
    </Paper>
  );
}

export default NavContent;
